import React from "react";
import CardStack from "./CardStack";

const stack = [
  // Frontend
  { icon: "fa-brands fa-react", head: "React" },
  { icon: "fa-brands fa-js", head: "JavaScript" },
  { icon: "fa-brands fa-html5", head: "HTML5" },
  { icon: "fa-brands fa-css3-alt", head: "CSS3" },
  { icon: "fa-brands fa-bootstrap", head: "Bootstrap" },
  { icon: "fa-solid fa-wind", head: "Tailwind CSS" },

  // Backend
  { icon: "fa-brands fa-node-js", head: "Node.js" },
  { icon: "fa-solid fa-server", head: "Express.js" },

  // Databases
  { icon: "fa-solid fa-database", head: "MongoDB" },
  { icon: "fa-solid fa-database", head: "MySQL" },

  // Programming Languages
  { icon: "fa-brands fa-python", head: "Python" },
  { icon: "fa-solid fa-c", head: "C" },
  { icon: "fa-solid fa-code", head: "C++" },

  // Tools
  { icon: "fa-brands fa-git-alt", head: "Git" },
  { icon: "fa-brands fa-linux", head: "Linux" },

  // Machine Learning
  { icon: "fa-solid fa-brain", head: "Machine Learning" },
  { icon: "fa-solid fa-chart-line", head: "Deep Learning" },
  { icon: "fa-solid fa-robot", head: "Artificial Intelligence" },
  
];

function TechStack() {
  return (
    <section className="container mt-5">
      <h2 className="section-title">Tech Stack & Skills</h2>
      <div className="tech-grid">
        {stack.map((tech) => (
          <CardStack
            key={tech.head}
            icon={tech.icon}
            head={tech.head}
          />
        ))}
      </div>
    </section>
  );
}

export default TechStack;